export const arrayMove = <T = string>(
  array: T[],
  oldIndex: number,
  newIndex: number
): { newArray: T[]; movedItems: T[]; minIndex: number; maxIndex: number } => {
  if (oldIndex === newIndex || oldIndex < 0 || newIndex < 0 || oldIndex >= array.length || newIndex >= array.length) {
    return { newArray: array, movedItems: [], minIndex: 0, maxIndex: 0 };
  }

  const itemToMove = array[oldIndex];
  const newArray = [...array];

  newArray.splice(oldIndex, 1);
  newArray.splice(newIndex, 0, itemToMove);

  const minIndex = Math.min(oldIndex, newIndex);
  const maxIndex = Math.max(oldIndex, newIndex);

  const movedItems = newArray.slice(minIndex, maxIndex + 1);

  return { newArray, movedItems, minIndex, maxIndex };
};

export const arrayHasIntersection = <T = unknown>(arr1: T[], arr2: T[]): boolean => {
  return arr1.some((el1) => arr2.includes(el1));
};
